"use client"

import { cn } from "@/lib/utils"
import { Search } from "lucide-react"

interface BlogSearchProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

export function BlogSearch({
  value,
  onChange,
  placeholder = "Search posts...",
  className
}: BlogSearchProps) {
  return (
    <div className={cn("relative", className)}>
      <div className="absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none z-10">
        <Search className="w-4 h-4 sm:w-5 sm:h-5 text-text-muted" aria-hidden="true" />
      </div>
      <input
        type="search"
        name="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className="w-full bg-white border border-border rounded-lg sm:rounded-xl pl-10 sm:pl-12 pr-4 py-2.5 sm:py-3 text-sm sm:text-base text-text placeholder:text-text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
        aria-label="Search blog posts"
      />
    </div>
  )
}
